import { setupRedeemForm, submitRedeemForm } from './redeem';
// import { setupOverrideForm, submitOverrideForm } from './override';

const queryString = require("query-string");

const { appConfig, $, Rollbar, loadingScreen, location, Pikaday, notie } = window;

export default function () {

  $("#voucher-list").on("click", e => {
    let voucher_id = $("#voucher_id").val();
    e.preventDefault();
    let url;
    if ($("#restaurant-group").val() == "1") {
      url = `/dashboard/v2/group/voucher_marketplaces/redeem_list.html?locale=${appConfig.locale}`;
    } else {
      url = `/dashboard/v2/voucher_marketplaces/redeem_list.html?locale=${appConfig.locale}`;
    }

    $.ajax({
      url: 'get_redeem_list?id=' + voucher_id,
      method: "GET",
      success(res) {
        if (res.success) {
          $.get(url).done(html => {
            const modal = $(html).simpleModal();
            var nominal = Intl.NumberFormat().format(res.data.voucher_price)
            $(".voucher_redeem").html("Voucher " + res.data.voucher_id);
            $(".voucher_title").html(res.data.voucher_title + " " + "<span style='color:red;' class='voucher_price'></span>");
            $(".voucher_price").html("฿ "+nominal);
            $(".voucher_name").val(res.data.voucher_name);
            $(".voucher_phone").val(res.data.voucher_phone);
            $(".voucher_code").html("Voucher Number: <span style='color:red;'>"+res.data.voucher_code+"</span>");
            $(".code_ticket").val(res.data.voucher_code);
            var dateRedeemOld = new Date(res.data.voucher_date_redeem);
            var dateRedeem = dateRedeemOld.toDateString('dd MM yyyy');
            var dateVoucherOld = new Date(res.data.voucher_valid_end_date);
            var dateVoucher = dateVoucherOld.toDateString('dd MM yyyy');
            if (res.data.voucher_status_active === false){
              $(".btn-submit-vmp").attr("disabled", true)
              $(".btn-submit-vmp").css({"background-color":"#B9B9B9","color":"#5E5E5E"});
              $(".btn-submit-vmp").val("Can't Redeem")
            } else {
              if (res.data.voucher_status_redeem) {
                $(".btn-submit-vmp").attr("disabled", true)
                $(".btn-submit-vmp").css({"background-color":"#B9B9B9","color":"#5E5E5E"});
                $(".btn-submit-vmp").val("Redeemed On:"+ " " + dateRedeem)
              }else{
                if (res.data.voucher_valid_date){
                  $(".btn-submit-vmp").attr("disabled", false)
                  $(".btn-submit-vmp").val("Confirm Redemption")
                }else{
                  $(".btn-submit-vmp").attr("disabled", true)
                  $(".btn-submit-vmp").css({"background-color":"#B9B9B9","color":"#5E5E5E"});
                  $(".btn-submit-vmp").val("Expired On:"+ " "+ dateVoucher)
                }
              }
            }
            modal.trigger("show");
            if ($(window).width() < 768) {
              modal.css("left", "3%").css("top", "3%");
            } else {
              modal.css("left", "35%").css("top", "18%");
            }
      
            modal.find(".cancel-modal").on("click", f => {
              f.preventDefault();
              modal.trigger("hide");
            });
          });
        } else {
          alert(res.message)
          Rollbar.error("Voucher Code Not Found", {
            msg: res.message
          });
        }
      },
      error(res) {
        alert("Voucher Code Not Found")
        Rollbar.error("Voucher Code Not Found", {
          msg: res.message
        });
      }
    });
  });

  $("#voucher-history").on("click", e => {
    let voucher_id = $("#voucher_id").val();
    e.preventDefault();
    let url;
    if ($("#restaurant-group").val() == "1") {
      url = `/dashboard/v2/group/voucher_marketplaces/redeem_history.html?locale=${appConfig.locale}`;
    } else {
      url = `/dashboard/v2/voucher_marketplaces/redeem_history.html?locale=${appConfig.locale}`;
    }
    $.ajax({
      url: 'get_redeem_history?id=' + voucher_id,
      method: "GET",
      success(res) {
        if (res.success) {
          $.get(url).done(html => {
            const modal = $(html).simpleModal();
            $(".voucher_name").val(res.data.voucher_name);
            $(".voucher_phone").val(res.data.voucher_phone);
            $(".code_ticket").val(res.data.voucher_code);
            modal.trigger("show");
            if ($(window).width() < 768) {
              modal.css("left", "3%").css("top", "3%");
            } else {
              modal.css("left", "35%").css("top", "18%");
            }
      
            modal.find(".cancel-modal").on("click", f => {
              f.preventDefault();
              modal.trigger("hide");
            });
          });
        } else {
          alert(res.message)
          Rollbar.error("voucher id not found", {
            msg: res.message
          });
        }
      },
      error(response) {
        alert("Voucher Code Not Found")
        Rollbar.error("voucher id not found", {
          msg: response.message
        });
      }
    });
  });
  
  $( "button.editHistory" ).click(function(e) {
    var id = $(this).data('history');
    e.preventDefault();
    let url;
    if ($("#restaurant-group").val() == "1") {
      url = `/dashboard/v2/group/voucher_marketplaces/redeem_history.html?locale=${appConfig.locale}`;
    } else {
      url = `/dashboard/v2/voucher_marketplaces/redeem_history.html?locale=${appConfig.locale}`;
    }
    $.ajax({
      url: 'get_redeem_history?id=' + id.slice(3),
      method: "GET",
      success(res) {
        if (res.success) {
          $.get(url).done(html => {
            const modal = $(html).simpleModal();
            $(".voucher_name").val(res.data.voucher_name);
            $(".voucher_phone").val(res.data.voucher_phone);
            $(".code_ticket").val(res.data.voucher_code);
            modal.trigger("show");
            if ($(window).width() < 768) {
              modal.css("left", "3%").css("top", "3%");
            } else {
              modal.css("left", "35%").css("top", "18%");
            }
      
            modal.find(".cancel-modal").on("click", f => {
              f.preventDefault();
              modal.trigger("hide");
            });
          });
        } else {
          alert(res.message)
          Rollbar.error("voucher id not found", {
            msg: res.message
          });
        }
      },
      error(response) {
        alert("Voucher Code Not Found")
        Rollbar.error("voucher id not found", {
          msg: response.message
        });
      }
    });
  });

}

